import { Stack } from "@chakra-ui/react"
import Card from "@pathwright/ui/src/components/card/Card"
import CardLink from "@pathwright/ui/src/components/card/CardLink"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { useTranslate } from "@pathwright/ux/src/components/lng/withTranslate"
import PathwrightAccountPermissions from "lib/core/components/pathwright/PathwrightAccountPermissions"
import { ConnectStores } from "lib/core/store"
import GroupDetailsForm from "./GroupDetailsForm"

const getLinkData = (t) => ({
  features: {
    icon: "bullet-list",
    label: t("Edit Cohort Description"),
    meta: t("Describe any unique benefits in this Cohort."),
    relativeTo: "features"
  },
  access: {
    icon: "calendar",
    label: t("Configure availability"),
    meta: t("Set registration windows, seat, and access limits."),
    relativeTo: "access"
  },
  communitySettings: {
    icon: "group",
    label: t("Configure community settings"),
    meta: t("Enable or disable Community interactions"),
    relativeTo: "community"
  },
  commerce: {
    icon: "tag-dollar-sign",
    label: t("Configure Commerce"),
    meta: t("Set a price to join or add to a Subscription plan."),
    relativeTo: "commerce"
  },
  archive: {
    icon: "trash",
    label: t("Delete Cohort"),
    meta: t("Permanently delete this Cohort."),
    relativeTo: "archive",
    dangerous: true
  }
})

const GroupDetails = function (props) {
  const { t } = useTranslate()
  const {
    group,
    onPristine,
    onDirty,
    hideFeaturesCardLink = false,
    hideCommunitySettingsCardLink = false,
    hideAccessCardLink = false,
    hideCommerceCardLink = false,
    hideArchiveCardLink = false
  } = props
  const canDelete =
    !!group?.id &&
    !group?.is_curriculum &&
    // Prevent accessing the archive card for child Cohorts as we don't allow directly
    // archiving child Cohorts, only via archiving the parent (Collection) Cohort.
    !group.parent_offering_id
  const linksData = getLinkData(t)

  return (
    <Stack w="100%">
      {group ? (
        <>
          <GroupDetailsForm
            onPristine={() => onPristine?.(false)}
            onDirty={() => onDirty?.(true)}
          />
          {!hideFeaturesCardLink && <CardLink {...linksData.features} />}
          {!hideAccessCardLink && <CardLink {...linksData.access} />}
          {!hideCommunitySettingsCardLink && (
            <CardLink {...linksData.communitySettings} />
          )}
          <PathwrightAccountPermissions offering={group}>
            {({ can_edit_offering_commerce }) => {
              return (
                can_edit_offering_commerce &&
                !hideCommerceCardLink && (
                  <CardLink
                    disabled={!!group.parent_offering_id}
                    tooltip={
                      !!group.parent_offering_id
                        ? "Currently unavailable for collection cohorts"
                        : null
                    }
                    {...linksData.commerce}
                  />
                )
              )
            }}
          </PathwrightAccountPermissions>
          {canDelete && !hideArchiveCardLink && (
            <CardLink {...linksData.archive} />
          )}
        </>
      ) : (
        <LoadingCircle center />
      )}
    </Stack>
  )
}

GroupDetails.displayName = "GroupDetails"

const mapStateToProps = function (state, ownProps) {
  const { group } = state.groupAdminStore.state
  return _.assign(
    {},
    {
      group
    },
    ownProps
  )
}

const connectStores = [
  {
    store: "groupAdmin",
    watch: ["group"]
  }
]

export const GroupDetailsConnected = ConnectStores(
  GroupDetails,
  connectStores,
  {},
  mapStateToProps
)

function GroupDetailsCard({ card, group }) {
  return (
    <Card card={card} title={group?.name || ""} titleTo={`${group?.url}path/`}>
      <GroupDetailsConnected
        onPristine={() => card.setCardDirty(false)}
        onDirty={() => card.setCardDirty(true)}
      />
    </Card>
  )
}

export default GroupDetailsCard
